
const StickyFooterBar = () => {
  return (
    <div className="fixed-bottom">
      <p>This app was created by <a href="https://github.com/JRose117/" target="_blank" rel="noreferrer">Joe</a>, <a href="https://github.com/millyarkwright" target="_blank" rel="noreferrer">Milly</a> & <a href="https://github.com/hal-alex" target="_blank" rel="noreferrer">Alex</a></p>
    </div>
  )
}
export default StickyFooterBar